export default {
  primary: 'UniversLTStd, Helvetica, sans-serif',
  primaryBoldCondensed: 'UniversLTStd-BoldCn, Helvetica, sans-serif',
};
